import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { wrapDecodingError } from "../../../internal/common/StitchErrorUtils";
import Method from "../../../internal/net/Method";
import { StitchAuthDocRequest } from "../../../internal/net/StitchAuthDocRequest";
import { StitchAuthRequest } from "../../../internal/net/StitchAuthRequest";
import StitchRequestError from "../../../StitchRequestError";
import { StitchRequestErrorCode } from "../../../StitchRequestErrorCode";
import CoreAuthProviderClient from "../internal/CoreAuthProviderClient";
import UserApiKey from "./models/UserApiKey";
import UserApiKeyAuthProvider from "./UserApiKeyAuthProvider";
var ApiKeyFields;

(function (ApiKeyFields) {
  ApiKeyFields["NAME"] = "name";
})(ApiKeyFields || (ApiKeyFields = {}));

var CoreUserApiKeyAuthProviderClient = function (_super) {
  __extends(CoreUserApiKeyAuthProviderClient, _super);

  function CoreUserApiKeyAuthProviderClient(requestClient, authRoutes) {
    var _this = this;

    var baseRoute = authRoutes.baseAuthRoute + "/api_keys";
    var name = UserApiKeyAuthProvider.DEFAULT_NAME;
    _this = _super.call(this, name, requestClient, baseRoute) || this;
    return _this;
  }

  CoreUserApiKeyAuthProviderClient.prototype.createApiKey = function (name) {
    var _a;

    var reqBuilder = new StitchAuthDocRequest.Builder();
    reqBuilder.withMethod(Method.POST).withPath(this.baseRoute).withDocument((_a = {}, _a[ApiKeyFields.NAME] = name, _a)).withRefreshToken();
    return this.requestClient.doAuthenticatedRequest(reqBuilder.build()).then(function (response) {
      return UserApiKey.readFromApi(response.body);
    })["catch"](function (err) {
      throw wrapDecodingError(err);
    });
  };

  CoreUserApiKeyAuthProviderClient.prototype.fetchApiKey = function (keyId) {
    var reqBuilder = new StitchAuthRequest.Builder();
    reqBuilder.withMethod(Method.GET).withPath(this.getApiKeyRoute(keyId.toHexString()));
    reqBuilder.withRefreshToken();
    return this.requestClient.doAuthenticatedRequest(reqBuilder.build()).then(function (response) {
      return UserApiKey.readFromApi(response.body);
    })["catch"](function (err) {
      throw wrapDecodingError(err);
    });
  };

  CoreUserApiKeyAuthProviderClient.prototype.fetchApiKeys = function () {
    var reqBuilder = new StitchAuthRequest.Builder();
    reqBuilder.withMethod(Method.GET).withPath(this.baseRoute);
    reqBuilder.withRefreshToken();
    return this.requestClient.doAuthenticatedRequest(reqBuilder.build()).then(function (response) {
      var json = JSON.parse(response.body);

      if (Array.isArray(json)) {
        return json.map(function (value) {
          return UserApiKey.readFromApi(value);
        });
      }

      throw new StitchRequestError(new Error("unexpected non-array response from server"), StitchRequestErrorCode.DECODING_ERROR);
    })["catch"](function (err) {
      throw wrapDecodingError(err);
    });
  };

  CoreUserApiKeyAuthProviderClient.prototype.deleteApiKey = function (keyId) {
    var reqBuilder = new StitchAuthRequest.Builder();
    reqBuilder.withMethod(Method.DELETE).withPath(this.getApiKeyRoute(keyId.toHexString()));
    reqBuilder.withRefreshToken();
    return this.requestClient.doAuthenticatedRequest(reqBuilder.build()).then(function () {});
  };

  CoreUserApiKeyAuthProviderClient.prototype.enableApiKey = function (keyId) {
    var reqBuilder = new StitchAuthRequest.Builder();
    reqBuilder.withMethod(Method.PUT).withPath(this.getApiKeyEnableRoute(keyId.toHexString()));
    reqBuilder.withRefreshToken();
    return this.requestClient.doAuthenticatedRequest(reqBuilder.build()).then(function () {});
  };

  CoreUserApiKeyAuthProviderClient.prototype.disableApiKey = function (keyId) {
    var reqBuilder = new StitchAuthRequest.Builder();
    reqBuilder.withMethod(Method.PUT).withPath(this.getApiKeyDisableRoute(keyId.toHexString()));
    reqBuilder.withRefreshToken();
    return this.requestClient.doAuthenticatedRequest(reqBuilder.build()).then(function () {});
  };

  CoreUserApiKeyAuthProviderClient.prototype.getApiKeyRoute = function (keyId) {
    return this.baseRoute + "/" + keyId;
  };

  CoreUserApiKeyAuthProviderClient.prototype.getApiKeyEnableRoute = function (keyId) {
    return this.getApiKeyRoute(keyId) + "/enable";
  };

  CoreUserApiKeyAuthProviderClient.prototype.getApiKeyDisableRoute = function (keyId) {
    return this.getApiKeyRoute(keyId) + "/disable";
  };

  return CoreUserApiKeyAuthProviderClient;
}(CoreAuthProviderClient);

export default CoreUserApiKeyAuthProviderClient;